(() => {
  const drawerSelector = '#ProductFilter';
  const openerSelector = '#btn-filter';

  const isVisible = (element) => Boolean(
    element
    && element.getClientRects().length
    && getComputedStyle(element).visibility !== 'hidden'
  );

  const getFocusableElements = (drawer) => [...drawer.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )].filter(isVisible);

  const prepareDrawer = () => {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return null;

    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    const label = drawer.querySelector('.text-result-filter')?.textContent.trim();
    if (label) drawer.setAttribute('aria-label', label);
    return drawer;
  };

  const syncSortControls = () => {
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      select.disabled = isDesktop ? select.id !== 'FormSelectFilter' : select.id === 'FormSelectFilter';
    });
  };

  const closeDrawer = (drawer) => {
    const closeButton = drawer.querySelector('#CloseFilter');
    if (!closeButton) return;
    closeButton.click();
    requestAnimationFrame(() => document.querySelector(openerSelector)?.focus());
  };

  document.addEventListener('click', (event) => {
    if (!event.target.closest(openerSelector)) return;
    window.setTimeout(() => {
      const drawer = prepareDrawer();
      if (isVisible(drawer)) drawer.querySelector('#CloseFilter')?.focus();
    }, 50);
  });

  document.addEventListener('keydown', (event) => {
    const drawer = prepareDrawer();
    if (!isVisible(drawer)) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer(drawer);
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = getFocusableElements(drawer);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('select[name="sort_by"]')) return;
    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      select.disabled = select !== event.target;
    });
  }, true);

  document.addEventListener('eurus:collection:reloaded', () => {
    prepareDrawer();
    syncSortControls();
  });
  window.addEventListener('resize', syncSortControls);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      prepareDrawer();
      syncSortControls();
    }, { once: true });
  } else {
    prepareDrawer();
    syncSortControls();
  }
})();
